import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { ButtonPrimitive } from '../../button-primitive/button-primitive.js';
import { icon, baseIconButton } from '../base-icon-button.module.css.js';
import { primary, fullRadius, highlighted, iconButton, secondary, ghost, largeSize } from './icon-button.module.css.js';

const VARIANT_CLASSES = {
    ghost: ghost,
    secondary: secondary,
    highlighted: highlighted,
    highlightedCircle: clsx(highlighted, fullRadius),
    primary: primary,
    primaryCircle: clsx(primary, fullRadius),
};
/**
 * Buttons let users initiate an action, acknowledge something, make a choice, or navigate.
 * Use an IconButton when you need a button that only contains an icon.
 *
 * @note If this button is used to toggle a state, consider using a {@link ToggleButton} instead.
 * @see https://fpl.figma.design/components/buttons/icon-button/
 */
const IconButton = forwardRef(({ children, variant = 'ghost', size = 'md', shape = 'square', ...props }, ref) => {
    // note: listen for data-tooltip={undefined} so the tooltip can be overridden.
    // i.e. look for key presence (x in y) rather than truthiness (!!x)
    let dataTooltip = props['aria-label'];
    if ('data-tooltip' in props) {
        dataTooltip = props['data-tooltip'];
    }
    const dataTooltipType = props['data-tooltip-type'] || 'text';
    return (jsx(ButtonPrimitive, { "data-fpl-component": "", ...props, ref: ref, "data-tooltip": dataTooltip, "data-tooltip-type": dataTooltipType, className: clsx(baseIconButton, iconButton, VARIANT_CLASSES[variant], {
            [fullRadius]: shape === 'circle',
            [largeSize]: size === 'lg',
        }), children: jsx("span", { "aria-hidden": true, className: icon, children: children }) }));
});
IconButton.displayName = 'IconButton';

export { IconButton };
//# sourceMappingURL=icon-button.js.map
